import { getCurrentScope } from '@sentry/vue';
import type { BeforeRequestHook } from 'ky';

export const useCustomSentryTransaction = () => {
	const transactionID = Math.random().toString(36).substr(2, 9);

	getCurrentScope().setTag('transaction_id', transactionID);

	return {
		transactionID,
	};
};

export const sentryTransactionHook: BeforeRequestHook = (request) => {
	const { transactionID } = useCustomSentryTransaction();
	request.headers.set('X-Transaction-ID', transactionID);
};
